import { Component } from '@angular/core';

@Component({
  selector: 'resource-center-side-bar',
  templateUrl: './resource-center-side-bar.component.html',
  styleUrl: './resource-center-side-bar.component.scss',
  standalone: false,
})
export class ResourceCenterComponent {}
